import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { LEAD_STAGES } from 'models/Lead';
import { getResolveUrl, getSellingPortfolio } from 'utils';

import './SoftSignalsLockedHint.styles.scss';

type SoftSignalsLockedHintProps = {
  className?: string;
};

// Explains a toggle locked by "One at a time", linking to the deal's first Automation stage.
const SoftSignalsLockedHint: React.FC<SoftSignalsLockedHintProps> = (props) => {
  const { className } = props;

  const {
    dataRoom: { dealRoomId },
  } = useContext(DataRoomContext);

  const classes = classNames('soft-signals-locked-hint', className);

  const { t } = useTranslation();

  // The Data Room is served on its own origin, so the link leaves it.
  const automationUrl = getResolveUrl(
    `${getSellingPortfolio(dealRoomId, 'settings')}/${LEAD_STAGES.ENQUIRE}`,
  );

  return (
    <p className={classes}>
      {t('softSignalsLockedOneAtATime')}{' '}
      <a href={automationUrl}>{t('changeThisInAutomation')}</a>
    </p>
  );
};

export default SoftSignalsLockedHint;
